function BlueText({ children, style, ...props }) {
    return <span style={{ color: "#1849F4", fontWeight: "bold",...style }} {...props}>{children}</span>
}

export default BlueText;